import { ProviderViewCallParticipant } from '../useProviderViewCallParticipants';
import { getTestCallParticipantVideo } from './getTestCallParticipantVideo';
import { testPatientData } from './testPatientData';
import { getTestWaitingMember } from './getTestWaitingMember';
import { RealtimeMemberStatus } from '../../features/realtime/realtime.types';
export type TestCallParticipant = ProviderViewCallParticipant & {
  videoElement: HTMLVideoElement;
};
export const getTestCallParticipant = (roomId: string): TestCallParticipant => {
  const waitingMember = getTestWaitingMember(roomId);
  return {
    ...waitingMember,
    state: {
      ...waitingMember.state,
      status: RealtimeMemberStatus.Busy,
    },
    username: testPatientData.username,
    hasVideo: true,
    hasAudio: true,
    videoElement: getTestCallParticipantVideo(testPatientData.videoUrl),
    videoDisabledReason: null,
    videoDisableWarning: false,
    hasScreenAudio: false,
  };
};
